import React from 'react'

const DefaultContent = ({ containerObject }) => {
    return (
        <>
        <p>DefaultContent</p>
        {containerObject && containerObject.targeterResult ? containerObject.targeterResult.map((oneContent)=>{
          return(<>
            <div dangerouslySetInnerHTML={{ __html: oneContent }}  ></div> 
          </>)
        })
       :""}

        </>
    )
}

export default DefaultContent